import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { documentListActions } from '@store/doc-viewer/document-list/document-list.actions';

@Injectable({ providedIn: 'root' })
export class TabSyncService {
  constructor(private store: Store, private actions$: Actions) {
    window.addEventListener('storage', (event) => {
      if (event.key === 'ContextMapping') {
        const updatedContextString = event.newValue;
        if (updatedContextString) {
          const updatedContext = JSON.parse(updatedContextString);
          this.store.dispatch(
            documentListActions.listUpdated({
              newDocumentList: updatedContext.docList,
              isExpandedResults: updatedContext.includeEmailFamiles ?? false
            })
          );
        }
      }
    });
  }
}
